import React from "react";

const FacebookWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="15"
      viewBox="0 0 8 15"
      fill="none"
    >
      <path
        d="M7.99984 2.48989L6.54978 2.49052C5.41284 2.49052 5.19272 3.01662 5.19272 3.7887V5.49108H7.90427L7.90331 8.15759H5.19272V15H2.36448V8.15759H0V5.49108H2.36448V3.52479C2.36448 1.24269 3.79613 0 5.88686 0L8 0.00327351L7.99984 2.48989Z"
        fill="white"
      />
    </svg>
  );
};

export default FacebookWhiteIcon;
